import { PaginatedAPI, QueriesAPIModel } from 'src/app/models/api.model'
import { QueriesDashboardModel } from 'src/app/models/model'

export interface QueryState {
  dashboard: QueriesDashboardModel
  details: QueriesAPIModel
  summary: PaginatedAPI<QueriesAPIModel>
}

export const initialQueriesashboardState: QueryState = {
  dashboard: undefined,
  details: undefined,
  summary: undefined
}
